import { useQuery } from 'react-query';

import { MatterOverviewResponseDto } from '../../../../backend/src/matter/dto/matter-overview.response.dto';
import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetMatterOverview = (matterId: string | null = '') => {
  const { fetchConfigGET } = useGetFetchConfig();

  const getMatterOverview = async (): Promise<MatterOverviewResponseDto> => {
    const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/overview`, fetchConfigGET);
    if (!response.ok) {
      throw new Error('Fetching matter overview failed');
    }

    return await response.json();
  };

  return useQuery([QueryEntity.MatterOverview, { matterId }], getMatterOverview, {
    refetchOnWindowFocus: false,
    enabled: !!matterId,
  });
};
